import { render, staticRenderFns } from "./BubblePreview.vue?vue&type=template&id=a1954c48&scoped=true"
import script from "./BubblePreview.vue?vue&type=script&lang=js"
export * from "./BubblePreview.vue?vue&type=script&lang=js"
import style0 from "./BubblePreview.vue?vue&type=style&index=0&id=a1954c48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1954c48",
  null
  
)

export default component.exports